import type { TypographyProps } from "@mui/material";
import type { TabularDataCell } from "../../../../../../../api/types/svTypes.ts";
import { buildTabularCell } from "./utils/buildTabularCell.tsx";

interface GroupingLeafCellProps {
  cell: TabularDataCell | undefined;
  typographyProps?: TypographyProps;
}

export const GroupingLeafCell = ({ cell, typographyProps }: GroupingLeafCellProps) => {
  return buildTabularCell({
    cellType: "groupLeaf",
    cell,
    formattedValue: cell?.formattedValue,
    typographyProps,
  });
};

export default GroupingLeafCell;
